import { BasePage } from "@Tenants/Fun/Site/BasePage";
import { BaseProduct } from "@Base/Product/Product";
import { Layout } from "./Layout";

import "./Product.scss";

export class Product extends BaseProduct
{
	public Layout: Layout;

	constructor()
	{
		super();
	}

	public Initialize(): void
	{
		super.Initialize();
		this.Layout = new Layout();
	};
}

export class ProductPage extends BasePage
{
	public Product: Product;
	constructor()
	{
		super();
		this.Initialize();
	}

	public async Initialize(): Promise<void>
	{
		super.Initialize();
		this.Product = new Product();
	};
}

const product = new ProductPage();